import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

import HomeView from '@/views/home/HomeView.vue';
import BlankCareerView from '@/views/home/BlankCareerView.vue';
import BlankInterviewView from '@/views/home/BlankInterviewView.vue';
import WaitInterviewView from '@/views/home/WaitInterviewView.vue';
import { useStore } from 'vuex';
import { onBeforeMount } from 'vue';
import { computed } from '@vue/reactivity';
import { UserMenu } from '@/types';
import { useRouter } from 'vue-router';
import cookies from 'vue-cookies';


export default /*#__PURE__*/_defineComponent({
  __name: 'Index',
  setup(__props) {

const router = useRouter();
const store = useStore();

const menu = computed<UserMenu>(() => {
  return store.getters['userMenu/userMenu'];
});

onBeforeMount(async () => {
  await store.dispatch('userMenu/receive');
  if (menu.value.displayContents === 5) {
    router.replace({ name: 'n10' });
  }

  // 求職者IDを取得してcookieに格納（初回のみ）
  if (cookies.isKey('userId01_c') === false) {
    await store.dispatch('careerId/receive');
    cookies.set('userId01_c', store.getters['careerId/careerId']);
  }

});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_unref(menu).displayContents === 1)
      ? (_openBlock(), _createBlock(BlankCareerView, {
          key: 0,
          menu: _unref(menu)
        }, null, 8, ["menu"]))
      : _createCommentVNode("", true),
    (_unref(menu).displayContents === 2)
      ? (_openBlock(), _createBlock(BlankInterviewView, { key: 1 }))
      : _createCommentVNode("", true),
    (_unref(menu).displayContents === 3 || _unref(menu).displayContents === 4)
      ? (_openBlock(), _createBlock(WaitInterviewView, {
          key: 2,
          menu: _unref(menu)
        }, null, 8, ["menu"]))
      : _createCommentVNode("", true),
    (_unref(menu).displayContents === 6)
      ? (_openBlock(), _createBlock(HomeView, { key: 3 }))
      : _createCommentVNode("", true)
  ], 64))
}
}

})